import { call, put, select, takeEvery } from 'typed-redux-saga'
import { errorHandler, gridSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { ResponseCatalog } from 'Models'
import {
	departmentsLogsSlice,
	DepartmentsLogsNS,
	DepartmentLogModel,
	departmentsLogsSelector,
	departmentLogsApi,
} from 'Pages/logs'

function* getAll(action: DepartmentsLogsNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		if (clear) {
			yield* put(departmentsLogsSlice.actions.clearAll())
		}
		const res = yield* call(departmentLogsApi.getAll, params)
		const logsResponse = new ResponseCatalog<DepartmentLogModel>(res)
		logsResponse.entries = logsResponse.entries.map(
			(log): DepartmentLogModel => Deserialize(log, DepartmentLogModel)
		)
		if (!clear) {
			const oldLogs = yield* select(departmentsLogsSelector.getAll)
			logsResponse.entries = [...oldLogs.entries, ...logsResponse.entries]
		}
		yield* put(departmentsLogsSlice.actions.setAll(logsResponse))
		yield* put(departmentsLogsSlice.actions.setRequestParams(params))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}
export function* departmentLogsSaga() {
	yield* takeEvery(departmentsLogsSlice.actions.getAll, getAll)
}
